
import clsx from 'clsx';
import React from 'react';

type Props = { html?: string; className?: string };

function RawHtml(props: Props) {
  const { html = '', className } = props;
   
  return <div className={clsx('flow', className)} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default RawHtml;


